import { Ratings } from '@/types';
import { getParams, isShopMode } from '@/utils/params';
import { getRequest } from './methods/getRequest';
import { requestToJSON } from './methods/requestToJSON';

export const fetchProductTypeRatings = () =>
  requestToJSON<Record<string, { count: string; rating: string }>>(
    getRequest(
      `https://www.spreadshirt.${
        getParams().platform === 'EU' ? 'net' : 'com'
      }/shopData/ratings?locale=${getParams().locale}${isShopMode() ? '&type=localeBased' : ''}`
    )
  ).then((data) =>
    Object.entries(data).reduce<Ratings>((result, [productTypeId, value]) => {
      result[productTypeId] = {
        count: parseInt(value.count, 10),
        rating: parseFloat(value.rating) || 0,
      };
      return result;
    }, {})
  );
